module.exports = new __parcel__URL__("shopping_cart_success.e784a9e2.svg").toString();